<template>
  <footer class="footer">
    <v-container style="max-width: 1700px;" class="mx-auto">
      <v-row>
        <!-- Logo and Contact Info -->
        <v-col cols="12" md="4" class="footer-left">
          <div class="footer-logo">
            <router-link to="/">
              <img
                src="assets/logo.png"
                alt="INTERNATIONAL EDU TRAVEL"
                class="footer-logo-img"
              />
            </router-link>
          </div>

          <div class="contact-info">
            <a href="mailto:contact@edtravel.mn" class="contact-link">
              contact@edtravel.mn
            </a>
            <span class="separator">|</span>
            <a href="mailto:ticket@edtravel.mn" class="contact-link">
              ticket@edtravel.mn
            </a>
            <span class="separator">|</span>
            <a href="mailto:sponsorship@edtravel.mn" class="contact-link">
              sponsorship@edtravel.mn
            </a>
          </div>
        </v-col>

        <!-- Navigation Links -->
        <v-col cols="12" md="5" class="footer-center">
          <!-- <div class="footer-links">
            <router-link to="/" class="footer-link">Home</router-link>
            <span class="link-separator">/</span>
            <span class="footer-link disabled">Speakers</span>
            <span class="link-separator">/</span>
            <router-link to="/agenda" class="footer-link">Agenda</router-link>
            <span class="link-separator">/</span>
            <router-link to="/startup-zone" class="footer-link">Startup Zone</router-link>
            <span class="link-separator">/</span>
            <router-link to="/partners" class="footer-link">Partners</router-link>
            <span class="link-separator">/</span>
            <router-link to="/media" class="footer-link">Media</router-link>
            <span class="link-separator">/</span>
            <span class="footer-link disabled">Media Kit</span>
            <span class="link-separator">/</span>
            <router-link to="/contact" class="footer-link">Contact Us</router-link>
          </div> -->
        </v-col>

        <!-- Social Media Icons -->
        <v-col cols="12" md="3" class="footer-right">
          <div class="social-icons">
            <a href="#" class="social-link" aria-label="Twitter/X">
              <v-icon color="white">mdi-twitter</v-icon>
            </a>
            <a href="#" class="social-link" aria-label="YouTube">
              <v-icon color="white">mdi-youtube</v-icon>
            </a>
            <a href="#" class="social-link" aria-label="LinkedIn">
              <v-icon color="white">mdi-linkedin</v-icon>
            </a>
            <a href="#" class="social-link" aria-label="Instagram">
              <v-icon color="white">mdi-instagram</v-icon>
            </a>
          </div>
        </v-col>
      </v-row>

      <v-divider class="footer-divider"></v-divider>

      <!-- Bottom Footer -->
      <v-row class="footer-bottom">
        <v-col cols="12" md="6" class="bottom-left">
          <div class="organizers">
            <span class="organizer-label">Organized</span>
            <div class="organizer-logo">
              <v-icon color="white">mdi-office-building</v-icon>
            </div>
            <span class="organizer-label">Powered by</span>
            <div class="organizer-logo">
              <v-icon color="white">mdi-clock-time-four</v-icon>
            </div>
          </div>
        </v-col>

        <v-col cols="12" md="6" class="bottom-right">
          <div class="footer-links-bottom">
            <a href="#" class="footer-link-small">General Policy</a>
            <a href="#" class="footer-link-small">FAQs</a>
            <a href="#" class="footer-link-small">Disclaimer</a>
            <a href="#" class="footer-link-small">Privacy Policy</a>
          </div>
          <p class="copyright">
            © Copyright 2025. All rights are reserved with edtravel
          </p>
        </v-col>
      </v-row>
    </v-container>
  </footer>
</template>

<script>
export default {
  name: "FooterSection",
};
</script>

<style scoped>
.footer {
  background-color: #1a1a2e;
  color: white;
  padding: 60px 0 30px;
}

/* Footer Logo */
.footer-left {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.footer-logo {
  display: flex;
  align-items: center;
}

.footer-logo a {
  display: flex;
  align-items: center;
  text-decoration: none;
}

.footer-logo-img {
  height: 60px;
  width: auto;
  transition: transform 0.3s ease;
}

.footer-logo-img:hover {
  transform: scale(1.05);
}

/* Contact Info */
.contact-info {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  font-size: 13px;
}

.contact-link {
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  transition: color 0.3s ease;
}

.contact-link:hover {
  color: #7c3aed;
}

.separator {
  color: rgba(255, 255, 255, 0.3);
}

/* Footer Links */
.footer-center {
  display: flex;
  align-items: flex-start;
  padding-top: 10px;
}

.footer-links {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  font-size: 14px;
}

.footer-link {
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  transition: color 0.3s ease;
}

.footer-link:hover:not(.disabled) {
  color: #7c3aed;
}

.footer-link.disabled {
  color: rgba(255, 255, 255, 0.4);
  cursor: not-allowed;
}

.link-separator {
  color: rgba(255, 255, 255, 0.3);
  margin: 0 4px;
}

/* Social Icons */
.footer-right {
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  padding-top: 10px;
}

.social-icons {
  display: flex;
  gap: 16px;
  color: white;
}

.social-link {
  color: white;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.social-link:hover {
  color: #7c3aed;
  transform: translateY(-2px);
}

.social-link .v-icon {
  font-size: 24px;
}

/* Divider */
.footer-divider {
  margin: 40px 0 30px;
  background-color: rgba(255, 255, 255, 0.1);
}

/* Bottom Footer */
.footer-bottom {
  margin-top: 20px;
}

.bottom-left {
  display: flex;
  align-items: center;
}

.organizers {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  color: white;
}

.organizer-label {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.6);
}

.organizer-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.organizer-logo .v-icon {
  font-size: 28px;
}

.bottom-right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 12px;
}

.footer-links-bottom {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.footer-link-small {
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  font-size: 13px;
  transition: color 0.3s ease;
}

.footer-link-small:hover {
  color: #7c3aed;
}

.copyright {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
  margin: 0;
  text-align: right;
}

/* Responsive Design */
@media (max-width: 960px) {
  .footer {
    padding: 40px 0 20px;
  }

  .footer-center,
  .footer-right {
    justify-content: flex-start;
    margin-top: 20px;
  }

  .social-icons {
    justify-content: flex-start;
  }

  .bottom-right {
    align-items: flex-start;
    margin-top: 20px;
  }

  .footer-links-bottom {
    justify-content: flex-start;
  }

  .copyright {
    text-align: left;
  }
}

@media (max-width: 600px) {
  .footer {
    padding: 35px 15px 15px;
  }

  .footer-left {
    gap: 16px;
  }

  .footer-logo-img {
    height: 50px;
  }

  .contact-info {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
    font-size: 12px;
  }

  .separator {
    display: none;
  }

  .footer-links {
    font-size: 12px;
  }

  .social-link .v-icon {
    font-size: 22px;
  }

  .organizers {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .organizer-label {
    font-size: 12px;
  }

  .organizer-logo .v-icon {
    font-size: 24px;
  }

  .footer-links-bottom {
    gap: 14px;
  }

  .footer-link-small {
    font-size: 12px;
  }

  .copyright {
    font-size: 11px;
  }

  .footer-divider {
    margin: 25px 0 18px;
  }
}

@media (max-width: 400px) {
  .footer {
    padding: 30px 12px 12px;
  }

  .footer-logo-img {
    height: 45px;
  }

  .contact-info {
    font-size: 11px;
  }

  .social-link .v-icon {
    font-size: 20px;
  }
}
</style>
